import * as _ from "lodash";
import * as log from "loglevel";
import * as React from "react";

import { JibunuFooterBar } from "@jibunu/footer-bar";
import { observable } from "mobx";
import { inject, observer, Provider } from "mobx-react";
import { Route, Switch, withRouter, } from "react-router-dom";
import { Button, Dimmer, Grid, Loader, Modal, Responsive } from "semantic-ui-react";

import { isMobile } from "react-device-detect";
import { AppStore } from "../stores/app-store";
import { AuthStore } from "../stores/auth-store";
import { ProjectStore } from "../stores/project-store";
import { StartMenuState, UIStore } from "../stores/ui-store";
import { UserStore } from "../stores/user-store";
import { AdminView } from "./admin/admin-view";
import { AppList } from "./apps/app-list";
import { AuditView } from "./audit-view";
import { AuthView } from "./auth/auth-view";
import { LoadingSpinner } from "./common/loading-spinner";
import { MobileWarning } from "./common/mobile-warning";
import { IntroModal } from "./intro-modal";
import { NavBar } from "./nav-bar";
import { ProjectDashboard } from "./projects/project-dashboard";
import { ProfileEditor } from "./users/profile-editor";
import { UserView } from "./users/user-view";

interface IMainViewProps{
	uiStore?: UIStore;
	authStore?: AuthStore;
	appStore?: AppStore;
	userStore?: UserStore;
	projectStore?: ProjectStore;
}

interface IMainViewState{
	errorMessage: string;
	showRedirect: string;
}


@inject("uiStore", "authStore", "appStore", "userStore", "projectStore") @observer
export class MainView extends React.Component<IMainViewProps, IMainViewState>{
	public timeout = null;

	constructor(props, state){
		super(props, state);

		this.state = {
			"errorMessage": null,
			"showRedirect": null
		};
		this.handleError = this.handleError.bind(this);
		this.cancelTimeout = this.cancelTimeout.bind(this);
		this.showRedirect = this.showRedirect.bind(this);
	}

	async componentDidMount(){
		if(!this.props.authStore.loggedIn){
			await this.props.authStore.loadAuth();
		}
	}

	async componentWillMount(){
		if(!this.props.authStore.loggedIn){
			await this.props.authStore.loadAuth();
		}
	}

	shouldComponentUpdate(nextProps: IMainViewProps, nextState: IMainViewState){
		//log.debug(nextProps, nextState, location.hash);
		if(location.hash == "#/"){
			return true;
		}
		else{
			return false;
		}
	}

	handleError(message: string){
		this.setState({"errorMessage": message});
	}

	showRedirect(loginURL){
		this.props.authStore.user.clearLoginURL();
		if(this.state.showRedirect !== loginURL){

			this.setState({
				"showRedirect": loginURL
			});

			clearTimeout(this.timeout);

			this.timeout = setTimeout(() => {
				window.location.href = loginURL;
			},                        15000);
		}
	}

	cancelTimeout(){
		clearTimeout(this.timeout);

		this.setState({
			"showRedirect": null
		});
	}

	render(){
		let navStyle: any = {
			"height": "68px",
			"position": "fixed",
			"top": "0px",
			"width": "100%",
			"zIndex": "102"
		};
		let contentStyle: any = {
			"marginTop": "68px",
			"marginBottom": "60px",
			"paddingBottom": "60px"
		};

		if(this.props.uiStore.startMenuState == StartMenuState.pinned){
			contentStyle = _.merge(contentStyle, {"paddingLeft": "400px"});
		}

		if(this.props.authStore.loggedIn && (this.props.authStore.requirements <= 0 || this.props.authStore.user.impersonate)){
			// console.log("post login url:", );
			let loginURL = this.props.authStore.user.postLoginRedirectURL;
			if(loginURL && loginURL.length > 0 && this.timeout === null){
				this.showRedirect(this.props.authStore.user.postLoginRedirectURL);
			}
			return(
				<div>
					{this.state.showRedirect !== null &&
					<>
						<Modal open basic >
							<Modal.Content>
								You will be redirected to your <a href={this.state.showRedirect}>custom portal</a> in 5 seconds...
								<br/><br/>
								If you wish to stay on this site please click the <i>Don't Redirect</i> button.
								<br/>
							</Modal.Content>
							<Modal.Actions>
								<Button floated="left" className="jibunu-red" onClick={this.cancelTimeout}>Don't Redirect</Button>
							</Modal.Actions>
						</Modal>
					</>}
					<div style={navStyle}>
						<NavBar />
					</div>
					<div style={contentStyle}>
						<Switch>
							<Route path="/apps" component={AppList} />
							<Route path="/history" component={AuditView} />
							<Route path="/users" component={UserView} />
							<Route path="/admin" component={AdminView} />
							<Route path="/profile" component={ProfileEditor} />
							<Route path="/" component={ProjectDashboard}/>
						</Switch>
					</div>
					{isMobile && !this.props.userStore.mobileWarningShown && <MobileWarning />}
					{this.props.uiStore.introModal && this.props.uiStore.optionsLoaded && !this.props.authStore.user.impersonate &&
						<IntroModal />
					}
					<JibunuFooterBar isoLabel="Confidential"/>
					{this.props.authStore.loading && <LoadingSpinner text="Authenticating" />}
				</div>
			);
		}
		else if(this.props.authStore.loading){
			return(<LoadingSpinner text="Authenticating" />);
		}
		else{
			return(
				<div style={contentStyle}>
					<AuthView />
					{isMobile && !this.props.userStore.mobileWarningShown && <MobileWarning />}
					<JibunuFooterBar isoLabel="Confidential"/>
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/main-view.tsx